import { ConfigurationShellApi } from './configurationShellApi/configurationShellApi';
import { TemplateShellApi } from './templateShellApi/templateShellApi';
import { AssetAdministrationShellRepositoryApi, SubmodelRepositoryApi } from 'api/v3/api';

export const repositoryClient = new AssetAdministrationShellRepositoryApi({ basePath: '/repo' });
export const configurationClient = new ConfigurationShellApi('/configuration');
export const templatesClient = new TemplateShellApi();
export const submodelClient = new SubmodelRepositoryApi({ basePath: '/repo' });
